angular.module('directives.dashboard').directive('wgtInfoSaleToLastYear', ['DashboardApiService',
        function (DashboardApiService) {
            return {
                templateUrl: 'directives/dashboard/widgets/wgtInfoSaleToLastYear/wgtInfoSaleToLastYear.tpl.html',
                link: function ($scope, $element) {
                    $scope.isLoaded = false;
                    $scope.hasError = false;
                    $scope.loadWidget = function () {
                        DashboardApiService.getWidgetData($scope.item.name, $scope.item.setting)
                            .then(function (response) {
                                $scope.widgetData = response.data;
                                if(angular.isString($scope.item.setting)){
                                    $scope.item.setting = JSON.parse($scope.item.setting);
                                    $scope.selectedWidgetTimeFrame = $scope.item.setting.selectedWidgetTimeFrame ? $scope.item.setting.selectedWidgetTimeFrame : 0;
                                }
                                $scope.isLoaded = true;
                                $scope.hasError = false;
                            }, function (response) {
                                $scope.hasError = true;
                            });
                    };

                    $scope.getDifferenceColour = function(value){
                        return  value > 0 ? "green" : 
                                value < 0 ? "red" : 
                                /*ELSE*/    "gray";
                    };
                    
                    $scope.loadWidget();
                }
            };
        }]
);
